
import { Exhibit } from '../types';

export const artExhibits: Exhibit[] = [
  {
    id: 1,
    numberCode: "101",
    titleEn: "The Persistence of Memory",
    titleHe: "התמדת הזיכרון",
    descriptionEn: "Salvador Dalí's famous 1931 painting featuring melting clocks, representing the fluidity of time.",
    descriptionHe: "ציור מפורסם של סלבדור דאלי משנת 1931 המציג שעונים נמסים, המסמלים את הנזילות של הזמן.",
    image: "https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7",
    hasAudio: true,
    hasVideo: false,
    audioTracks: [
      {
        url: "/audio/dali-persistence-memory.mp3",
        language: "en",
        type: "primary",
        mimeType: "audio/mpeg",
        audioDescriptions: [
          {
            url: "/audio/dali-persistence-memory-description.mp3",
            language: "en",
            verbosity: "medium",
            timestamps: [
              {
                time: 5,
                text: "The painting shows three melting pocket watches draped over various objects in a desert landscape.",
                duration: 4
              },
              {
                time: 15,
                text: "In the background, you can see golden cliffs and a calm blue sea under a pale sky.",
                duration: 3
              },
              {
                time: 25,
                text: "A dead tree branch extends from the left, supporting one of the melting clocks.",
                duration: 3
              }
            ]
          },
          {
            url: "/audio/dali-persistence-memory-description-detailed.mp3",
            language: "en",
            verbosity: "high",
            timestamps: [
              {
                time: 5,
                text: "The painting displays three melting pocket watches with precise detail, their surfaces appearing like soft cheese draped over a dead tree branch, a rectangular platform, and what appears to be an orange form.",
                duration: 6
              },
              {
                time: 18,
                text: "The background features the dramatic cliffs of Catalonia, Dalí's homeland, rendered in warm golden tones that contrast with the cool blue of the Mediterranean Sea.",
                duration: 5
              },
              {
                time: 30,
                text: "The composition includes precise shadows and realistic textures despite the surreal subject matter, demonstrating Dalí's masterful painting technique.",
                duration: 4
              }
            ]
          }
        ]
      }
    ],
    location: {
      floor: 2,
      room: "Gallery A",
      x: 150,
      y: 200
    }
  },
  {
    id: 2,
    numberCode: "102",
    titleEn: "Starry Night",
    titleHe: "ליל כוכבים",
    descriptionEn: "Vincent van Gogh's iconic painting from 1889, depicting a night scene with swirling clouds and a bright crescent moon.",
    descriptionHe: "הציור האייקוני של וינסנט ואן גוך משנת 1889, המציג נוף לילה עם עננים מסתחררים וירח חדש בהיר.",
    image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262",
    hasAudio: true,
    hasVideo: true,
    location: {
      floor: 2,
      room: "Gallery A",
      x: 250,
      y: 180
    }
  },
  {
    id: 5,
    numberCode: "103",
    titleEn: "The Scream",
    titleHe: "הצעקה",
    descriptionEn: "Edvard Munch's expressionist painting from 1893, depicting an agonized figure against a landscape with a tumultuous orange sky.",
    descriptionHe: "ציור אקספרסיוניסטי של אדוארד מונק משנת 1893, המציג דמות מיוסרת על רקע נוף עם שמיים כתומים סוערים.",
    image: "https://images.unsplash.com/photo-1584446922442-7ac6b8c118f4",
    hasAudio: true,
    hasVideo: false,
    location: {
      floor: 2,
      room: "Gallery B",
      x: 400,
      y: 150
    }
  },
  {
    id: 8,
    numberCode: "104",
    titleEn: "Abstract Expressionism",
    titleHe: "אקספרסיוניזם מופשט",
    descriptionEn: "A vibrant Jackson Pollock-inspired painting showcasing the spontaneous art movement.",
    descriptionHe: "ציור תוסס בהשראת ג'קסון פולוק המציג את תנועת האמנות הספונטנית.",
    image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262",
    hasAudio: false,
    hasVideo: true,
    location: {
      floor: 2,
      room: "Gallery B",
      x: 320,
      y: 250
    }
  }
];
